import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { huntingtonConfig } from "./data";

export default function HuntingtonPage() {
  return <CityPageTemplate config={huntingtonConfig} />;
}